// extracted by mini-css-extract-plugin
export default {"markdown":"index_markdown__OMnh8"};